export const FIELD_NAMES_ZH: Record<string, string> = {
  name: "名称",
  code: "code",
  telegramBotToken: "Bot Token",
  weight: "权重",
  miniAppUrl: "Mini App URL",
  suggestedUsername: "建议 username",
  imageUrl: "图片",
  type: "类型",
  valueAmount: "价值",
  stock: "库存",
  dailyLimit: "日上限",
  requiresShipping: "实物需要收件",
  isEnabled: "启用",
  currency: "货币",
  defaultLanguage: "默认语言",
};

export const fieldNameZh = (path: string): string => FIELD_NAMES_ZH[path] ?? path;
